import { render } from "./TreeNode.vue?vue&type=template&id=634fcf8e&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=634fcf8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634fcf8e"]])

export default __exports__